import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';

export default defineSection({
    head: sectionHead({title: 'Circle invitation'}),
    routes: [
        {
            path: '/users/invitation/code/:invitationCode/',
            component: () => import(/* webpackChunkName: "accountPages" */ './CircleInviteRegistrationPage.vue'),
            name: 'CircleInviteRegistrationPage',
            props: true,
        },
    ]
});
